import { render } from "./TrainingChartSingle.vue?vue&type=template&id=6a623d2a"
import script from "./TrainingChartSingle.vue?vue&type=script&lang=js"
export * from "./TrainingChartSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__